import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { calculateTotalLandArea } from '../../../utils/mockDossierData';
import './DossierLandInventory.css';

export function DossierLandInventory({ landInventory = [] }) {
  const { t } = useTranslation();
  const totalArea = useMemo(() => calculateTotalLandArea(landInventory), [landInventory]);

  if (landInventory.length === 0) {
    return null;
  }

  return (
    <div className="dossier-land-inventory">
      <div className="dossier-land-inventory__header">
        <h4 className="dossier-land-inventory__title">{t('reports.workspace.dossier.sections.landInventory.title')}</h4>
        <div className="dossier-land-inventory__total">{t('reports.workspace.dossier.sections.landInventory.total', { total: totalArea.toFixed(1) })}</div>
      </div>

      <div className="dossier-land-inventory__table">
        <div className="dossier-land-inventory__table-header">
          <div className="dossier-land-inventory__col-id">{t('reports.workspace.dossier.sections.landInventory.columns.id')}</div>
          <div className="dossier-land-inventory__col-sheet">{t('reports.workspace.dossier.sections.landInventory.columns.sheetNum')}</div>
          <div className="dossier-land-inventory__col-area">{t('reports.workspace.dossier.sections.landInventory.columns.area')}</div>
          <div className="dossier-land-inventory__col-crop">{t('reports.workspace.dossier.sections.landInventory.columns.crop')}</div>
        </div>
        {landInventory.map((parcel) => (
          <div key={parcel.id} className="dossier-land-inventory__row">
            <div className="dossier-land-inventory__col-id">{parcel.parcelId || parcel.id}</div>
            <div className="dossier-land-inventory__col-sheet">
              {parcel.sheetNumber}/{parcel.parcelNumber}
            </div>
            <div className="dossier-land-inventory__col-area">{parcel.area.toFixed(1)}</div>
            <div className="dossier-land-inventory__col-crop">{parcel.cropType || t('common.notAvailable')}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
